export const hasDataLayer = (): boolean => {
  return typeof window.dataLayer !== 'undefined' && typeof window.dataLayer.push === 'function';
};

// Máme potvrzení uživatele o souhlasu s cookies?
export const isDidomiConfirmed = (): boolean => {
  return window.didomiOnReady !== undefined;
};

// Splňuje klient podmínky pro trackování?
export const canTrack = (): boolean => {
  return hasDataLayer() && isDidomiConfirmed();
};

// Tracking události
export const GTMTrack = (event: string, data?: object): void => {
  if (canTrack())
    (async () => {
      window.didomiOnReady = window.didomiOnReady || [];
      await window.didomiOnReady.push(() => {
        window.dataLayer.push({
          event,
          ...data,
        });
      });
    })().then(() => {
      /* Po načtení dat s nimi nic neděláme */
    });
};

// Čeká event 'page_body' nebo 'page_ready' v dataLayeru
export const GTMPageBodyIsReady = (execute?: () => void, delay = 1000) => {
  if (!canTrack()) return;

  let isReady = false;
  while (!isReady) {
    if (
      window.dataLayer.some(
        (item: { event: string }) => item.event === 'page_body' || item.event === 'page_ready'
      )
    ) {
      isReady = true;
      if (execute) execute();
    } else {
      setTimeout(() => {
        GTMPageBodyIsReady(execute, delay);
      }, delay);
      break;
    }
  }
};
